/**
 * @file   古琴数字资源库-首页
 * @create macaiqi 2025/06/12
 * @update 
 */
import { useEffect, useState } from 'react';
import Footer from '../Footer';
import { Link } from 'react-router-dom';
import { apiSearch } from '../../../service';
import { useNav } from '../../../App';
import usePage from '../../../components/Hooks/usePage'
import List from '../ImgList/list';
import Mypager from '../../../components/Mypager';
import './index.scss'
export default function Index() {
    const { navData } = useNav();
    const [initPage, setPage] = usePage();
    const [key, setKey] = useState('')
    const [searchkey, setDearchkey] = useState('')
    const onSearch = (value) => {
        setPage(1)
        setDearchkey(value)
    }

    const [listdata, setListData] = useState()
    const [loading, setLoading] = useState()
    useEffect(() => {
        if (searchkey) {
            setLoading(true)
            apiSearch({
                params: {
                    channelId: localStorage.getItem("channelId"),
                    key: searchkey
                },
                pagination: {
                    size: 8,
                    page: initPage
                }
            }).then(res => {
                setListData(res)
                setLoading(false)

            })
        }

    }, [searchkey, initPage])
    return (
        <div className='library-page'>
            <div className="top">
                <i className="logo"></i>
                <div className="search">
                    <input type="text" placeholder='请输入关键词，点击搜索按钮进行检索' value={key} onChange={(e) => {
                        setKey(e.target.value || '')
                    }} onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.keyCode === 13) {
                            onSearch(key);
                        }
                    }} />
                    <div className="searchbtn" onClick={() => { onSearch(key) }}></div>
                </div>
            </div>
            <div className="content">
                {searchkey?.length > 0 ?
                    (listdata?.records?.length > 0 ?
                        <>
                            <List data={listdata} initPage={initPage} setPage={setPage} loading={loading} navData={navData} />
                            {listdata && listdata?.pages > 1 && initPage && <Mypager initialPage={initPage} pages={listdata?.pages} setPage={setPage} />}

                        </>
                        :
                        <p>暂无搜索结果</p>)
                    : <div className="tab">
                        {navData.map((item, index) => {
                            // console.log(item)
                            return (
                                <Link to={`/DigitalResourceLibrary/${item.channelNo}`} className="item" key={index} >
                                    <p className="title">
                                        {item?.channelName}
                                    </p>
                                </Link>
                            )
                        })}
                    </div>}

            </div>
            <Footer />
        </div>
    )
}
